"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Booking API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingApiServiceApi = exports.BookingApiServiceApiFactory = exports.BookingApiServiceApiFp = exports.BookingApiServiceApiAxiosParamCreator = exports.V1GuestProfileType = exports.V1DiscountCodeType = exports.V1AddOnDisplayType = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.V1AddOnDisplayType = {
    Unknown: 'ADD_ON_DISPLAY_TYPE_UNKNOWN',
    Toggle: 'ADD_ON_DISPLAY_TYPE_TOGGLE',
    Rocker: 'ADD_ON_DISPLAY_TYPE_ROCKER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1DiscountCodeType = {
    None: 'NONE',
    Promo: 'PROMO',
    Corporate: 'CORPORATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1GuestProfileType = {
    Unspecified: 'UNSPECIFIED',
    Guest: 'GUEST',
    Billing: 'BILLING'
};
/**
 * BookingApiServiceApi - axios parameter creator
 * @export
 */
const BookingApiServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This method is used to create the booking entry (not reserved yet).
         * @param {string} userAgent
         * @param {string} acceptLanguage
         * @param {V1CreateBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceCreateBooking: async (userAgent, acceptLanguage, body, options = {}) => {
            // verify required parameter 'userAgent' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceCreateBooking', 'userAgent', userAgent);
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceCreateBooking', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceCreateBooking', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/CreateBooking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (userAgent != null) {
                localVarHeaderParameter['User-Agent'] = String(userAgent);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to check availability of rooms.
         * @param {string} acceptLanguage
         * @param {V1GetAvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetAvailability: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetAvailability', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetAvailability', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetAvailability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method returns all available add-ons for a booking.
         * @param {string} acceptLanguage
         * @param {V1GetAvailableAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetAvailableAddOns: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetAvailableAddOns', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetAvailableAddOns', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetAvailableAddOns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method returns the booking summary given the booking id.
         * @param {string} acceptLanguage
         * @param {V1GetBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBooking: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBooking', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBooking', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetBooking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method gets details for a partcular payment method.
         * @param {string} acceptLanguage
         * @param {V1GetBookingPaymentMethodDetailsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBookingPaymentMethodDetails: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBookingPaymentMethodDetails', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBookingPaymentMethodDetails', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetBookingPaymentMethodDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method gets available payment methods for a booking.
         * @param {string} acceptLanguage
         * @param {V1GetBookingPaymentMethodsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBookingPaymentMethods: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBookingPaymentMethods', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBookingPaymentMethods', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetBookingPaymentMethods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method returns the booking status given the booking id.
         * @param {string} acceptLanguage
         * @param {V1GetBookingStatusRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBookingStatus: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBookingStatus', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetBookingStatus', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetBookingStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to return the calendar view of rooms.
         * @param {string} acceptLanguage
         * @param {V1GetCalendarRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetCalendar: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetCalendar', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetCalendar', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetCalendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to check availability of rooms across all hotels.
         * @param {string} acceptLanguage
         * @param {V1GetGlobalAvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetGlobalAvailability: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetGlobalAvailability', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceGetGlobalAvailability', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/GetGlobalAvailability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method adds or removes add-ons from a booking.
         * @param {string} acceptLanguage
         * @param {V1UpdateBookingAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceUpdateBookingAddOns: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceUpdateBookingAddOns', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingApiServiceUpdateBookingAddOns', 'body', body);
            const localVarPath = `/booking_api.v1.BookingApiService/UpdateBookingAddOns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BookingApiServiceApiAxiosParamCreator = BookingApiServiceApiAxiosParamCreator;
/**
 * BookingApiServiceApi - functional programming interface
 * @export
 */
const BookingApiServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BookingApiServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * This method is used to create the booking entry (not reserved yet).
         * @param {string} userAgent
         * @param {string} acceptLanguage
         * @param {V1CreateBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceCreateBooking(userAgent, acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceCreateBooking(userAgent, acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method is used to check availability of rooms.
         * @param {string} acceptLanguage
         * @param {V1GetAvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetAvailability(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetAvailability(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method returns all available add-ons for a booking.
         * @param {string} acceptLanguage
         * @param {V1GetAvailableAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetAvailableAddOns(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetAvailableAddOns(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method returns the booking summary given the booking id.
         * @param {string} acceptLanguage
         * @param {V1GetBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetBooking(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetBooking(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method gets details for a partcular payment method.
         * @param {string} acceptLanguage
         * @param {V1GetBookingPaymentMethodDetailsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetBookingPaymentMethodDetails(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetBookingPaymentMethodDetails(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method gets available payment methods for a booking.
         * @param {string} acceptLanguage
         * @param {V1GetBookingPaymentMethodsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetBookingPaymentMethods(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetBookingPaymentMethods(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method returns the booking status given the booking id.
         * @param {string} acceptLanguage
         * @param {V1GetBookingStatusRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetBookingStatus(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetBookingStatus(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method is used to return the calendar view of rooms.
         * @param {string} acceptLanguage
         * @param {V1GetCalendarRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetCalendar(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetCalendar(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method is used to check availability of rooms across all hotels.
         * @param {string} acceptLanguage
         * @param {V1GetGlobalAvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceGetGlobalAvailability(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceGetGlobalAvailability(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method adds or removes add-ons from a booking.
         * @param {string} acceptLanguage
         * @param {V1UpdateBookingAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingApiServiceUpdateBookingAddOns(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingApiServiceUpdateBookingAddOns(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.BookingApiServiceApiFp = BookingApiServiceApiFp;
/**
 * BookingApiServiceApi - factory interface
 * @export
 */
const BookingApiServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BookingApiServiceApiFp)(configuration);
    return {
        /**
         * This method is used to create the booking entry (not reserved yet).
         * @param {string} userAgent
         * @param {string} acceptLanguage
         * @param {V1CreateBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceCreateBooking(userAgent, acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceCreateBooking(userAgent, acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to check availability of rooms.
         * @param {string} acceptLanguage
         * @param {V1GetAvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetAvailability(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetAvailability(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method returns all available add-ons for a booking.
         * @param {string} acceptLanguage
         * @param {V1GetAvailableAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetAvailableAddOns(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetAvailableAddOns(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method returns the booking summary given the booking id.
         * @param {string} acceptLanguage
         * @param {V1GetBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBooking(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetBooking(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method gets details for a partcular payment method.
         * @param {string} acceptLanguage
         * @param {V1GetBookingPaymentMethodDetailsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBookingPaymentMethodDetails(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetBookingPaymentMethodDetails(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method gets available payment methods for a booking.
         * @param {string} acceptLanguage
         * @param {V1GetBookingPaymentMethodsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBookingPaymentMethods(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetBookingPaymentMethods(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method returns the booking status given the booking id.
         * @param {string} acceptLanguage
         * @param {V1GetBookingStatusRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetBookingStatus(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetBookingStatus(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to return the calendar view of rooms.
         * @param {string} acceptLanguage
         * @param {V1GetCalendarRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetCalendar(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetCalendar(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to check availability of rooms across all hotels.
         * @param {string} acceptLanguage
         * @param {V1GetGlobalAvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceGetGlobalAvailability(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceGetGlobalAvailability(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method adds or removes add-ons from a booking.
         * @param {string} acceptLanguage
         * @param {V1UpdateBookingAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingApiServiceUpdateBookingAddOns(acceptLanguage, body, options) {
            return localVarFp.bookingApiServiceUpdateBookingAddOns(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BookingApiServiceApiFactory = BookingApiServiceApiFactory;
/**
 * BookingApiServiceApi - object-oriented interface
 * @export
 * @class BookingApiServiceApi
 * @extends {BaseAPI}
 */
class BookingApiServiceApi extends base_1.BaseAPI {
    /**
     * This method is used to create the booking entry (not reserved yet).
     * @param {string} userAgent
     * @param {string} acceptLanguage
     * @param {V1CreateBookingRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceCreateBooking(userAgent, acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceCreateBooking(userAgent, acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method is used to check availability of rooms.
     * @param {string} acceptLanguage
     * @param {V1GetAvailabilityRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetAvailability(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetAvailability(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method returns all available add-ons for a booking.
     * @param {string} acceptLanguage
     * @param {V1GetAvailableAddOnsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetAvailableAddOns(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetAvailableAddOns(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method returns the booking summary given the booking id.
     * @param {string} acceptLanguage
     * @param {V1GetBookingRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetBooking(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetBooking(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method gets details for a partcular payment method.
     * @param {string} acceptLanguage
     * @param {V1GetBookingPaymentMethodDetailsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetBookingPaymentMethodDetails(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetBookingPaymentMethodDetails(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method gets available payment methods for a booking.
     * @param {string} acceptLanguage
     * @param {V1GetBookingPaymentMethodsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetBookingPaymentMethods(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetBookingPaymentMethods(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method returns the booking status given the booking id.
     * @param {string} acceptLanguage
     * @param {V1GetBookingStatusRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetBookingStatus(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetBookingStatus(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method is used to return the calendar view of rooms.
     * @param {string} acceptLanguage
     * @param {V1GetCalendarRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetCalendar(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetCalendar(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method is used to check availability of rooms across all hotels.
     * @param {string} acceptLanguage
     * @param {V1GetGlobalAvailabilityRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceGetGlobalAvailability(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceGetGlobalAvailability(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method adds or removes add-ons from a booking.
     * @param {string} acceptLanguage
     * @param {V1UpdateBookingAddOnsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApiServiceApi
     */
    bookingApiServiceUpdateBookingAddOns(acceptLanguage, body, options) {
        return (0, exports.BookingApiServiceApiFp)(this.configuration).bookingApiServiceUpdateBookingAddOns(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BookingApiServiceApi = BookingApiServiceApi;
